import { exportCSV, exportKML } from "../modules/exporter";
import "./ExportPanel.css";

/*
  ExportPanel.jsx — Export buttons (version 1.3)
  CSV and KML both active.
*/

export default function ExportPanel({ records, vesselName }) {
  if (!records || records.length === 0) return null;

  function buildFilename(ext) {
    const name = (vesselName || "vessel").replace(/\s+/g, "_").toUpperCase();
    const first = records[0]?.timestamp?.slice(0, 10) || "unknown";
    const last = records[records.length - 1]?.timestamp?.slice(0, 10) || "unknown";
    return `AISsift_${name}_${first}_to_${last}.${ext}`;
  }

  function handleCSVExport() {
    exportCSV(records, buildFilename("csv"));
  }

  function handleKMLExport() {
    exportKML(records, buildFilename("kml"));
  }

  return (
    <div className="export-panel">
      <h3 className="export-title">Export</h3>
      <p className="export-desc">
        {records.length.toLocaleString()} records ready to export.
      </p>
      <div className="export-buttons">
        <button className="export-button" onClick={handleCSVExport}>
          Download CSV
        </button>
        <button className="export-button" onClick={handleKMLExport}>
          Download KML
        </button>
      </div>
      <p className="export-note">
        KML opens in Google Earth. Use the time slider to animate the vessel track.
      </p>
    </div>
  );
}
